import { render, staticRenderFns } from "./DoubletProcessingPage.vue?vue&type=template&id=112f7d78"
import script from "./DoubletProcessingPage.vue?vue&type=script&lang=js"
export * from "./DoubletProcessingPage.vue?vue&type=script&lang=js"
import style0 from "./DoubletProcessingPage.vue?vue&type=style&index=0&id=112f7d78&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports